import type { Affirmation, AffirmationSet, Gender, PracticeIn, PresetId, Working } from "@mantra/shared";
import Dexie, { type EntityTable } from "dexie";

/** dirty = 1 — запись изменена локально и ещё не подтверждена сервером */
export type LocalSet = AffirmationSet & { dirty: 0 | 1 };
export type LocalAffirmation = Affirmation & { dirty: 0 | 1 };
export type LocalPractice = PracticeIn & { dirty: 0 | 1 };
export type LocalWorking = Working & { dirty: 0 | 1 };

export interface ClipMeta {
  hash: string;
  url: string;
  durationMs: number;
  cachedAt: number;
}

export interface KvRow {
  key: string;
  value: unknown;
}

export interface Profile {
  gender: Gender;
  defaultPreset: PresetId;
  /** голос для новых настроев; если не выбран — по роду обращения */
  defaultVoice?: string;
}

class MantraDb extends Dexie {
  sets!: EntityTable<LocalSet, "id">;
  affirmations!: EntityTable<LocalAffirmation, "id">;
  practice!: EntityTable<LocalPractice, "id">;
  clips!: EntityTable<ClipMeta, "hash">;
  workings!: EntityTable<LocalWorking, "id">;
  kv!: EntityTable<KvRow, "key">;

  constructor() {
    super("mantra");
    this.version(1).stores({
      sets: "id, updatedAt, dirty",
      affirmations: "id, setId, [setId+position], dirty",
      practice: "id, dirty, startedAt",
      clips: "hash",
      kv: "key",
    });
    // 0.5: проработки в тренажёрах
    this.version(2).stores({ workings: "id, trainerId, updatedAt, status, dirty" });
  }
}

export const db = new MantraDb();

export async function kvGet<T>(key: string): Promise<T | undefined> {
  return (await db.kv.get(key))?.value as T | undefined;
}

export async function kvSet(key: string, value: unknown): Promise<void> {
  await db.kv.put({ key, value });
}

export async function kvDel(key: string): Promise<void> {
  await db.kv.delete(key);
}
